import { CAREER_SITE_ID } from '../config/constants';

export const getSourceId = () => {
    const params = new URLSearchParams(window.location.search);
    const source = parseInt(params.get('source'), 10);
    return Number.isNaN(source) ? CAREER_SITE_ID : source;
};
